import React from 'react'
import 'antd/dist/reset.css'
import './App.css'
import { Link, Navigate, Outlet, Route, Routes, useLocation } from 'react-router-dom'
import { Teams } from './pages/teams'
import { Positions } from './pages/positions'
import { Players } from './pages/players'
import { TrainingGames } from './pages/training-games'
import { TrainingFields } from './pages/training-fields'
// import { TrainingGamesPlayers } from './pages/training-games-players'
import { Game } from './pages/training-games/game'
import { Login } from './pages/login'
import { useAuth } from './contexts/auth'
import { Leagues } from './pages/leagues'
import { Games } from './pages/leagues/games'
import { ScoreTable } from './pages/leagues/score-table'
import { ScorerTable } from './pages/leagues/scorer-table'
import { Bracket } from './pages/leagues/bracket'
import LeagueTypes from './pages/league-types'
import { Documents } from './pages/documents'
import { Users } from './pages/users'
import LeagueDivisions from './pages/league-divisions'
import LeagueFormats from './pages/league-formats'

export function App() {
    return (
        <Routes>
            <Route element={<Layout />}>
                <Route path='/' element={<Home />} />
                <Route path='/login' element={<Login />} />
                <Route
                    path='/leagues/:league/games'
                    element={
                        <RequireAuth>
                            <Games />
                        </RequireAuth>
                    }
                />
                <Route
                    path='/leagues/:league/score-table'
                    element={
                        <RequireAuth>
                            <ScoreTable />
                        </RequireAuth>
                    }
                />
                <Route
                    path='/leagues/:league/scorer-table'
                    element={
                        <RequireAuth>
                            <ScorerTable />
                        </RequireAuth>
                    }
                />
                <Route
                    path='/leagues/:league/bracket'
                    element={
                        <RequireAuth>
                            <Bracket />
                        </RequireAuth>
                    }
                />
                <Route
                    path='/leagues'
                    element={
                        <RequireAuth>
                            <Leagues />
                        </RequireAuth>
                    }
                />
                <Route
                    path='/league-types'
                    element={
                        <RequireAuth>
                            <LeagueTypes />
                        </RequireAuth>
                    }
                />
                <Route
                    path='/league-divisions'
                    element={
                        <RequireAuth>
                            <LeagueDivisions />
                        </RequireAuth>
                    }
                />
                <Route
                    path='/league-formats'
                    element={
                        <RequireAuth>
                            <LeagueFormats />
                        </RequireAuth>
                    }
                />
                <Route
                    path='/teams'
                    element={
                        <RequireAuth>
                            <Teams />
                        </RequireAuth>
                    }
                />
                <Route
                    path='/positions'
                    element={
                        <RequireAuth>
                            <Positions />
                        </RequireAuth>
                    }
                />
                <Route
                    path='/players'
                    element={
                        <RequireAuth>
                            <Players />
                        </RequireAuth>
                    }
                />
                <Route
                    path='/documents'
                    element={
                        <RequireAuth>
                            <Documents />
                        </RequireAuth>
                    }
                />
                <Route
                    path='/training-fields'
                    element={
                        <RequireAuth>
                            <TrainingFields />
                        </RequireAuth>
                    }
                />
                <Route
                    path='/training-games'
                    element={
                        <RequireAuth>
                            <TrainingGames />
                        </RequireAuth>
                    }
                />
                <Route
                    path='/training-games/:gameId'
                    element={
                        <RequireAuth>
                            <Game />
                        </RequireAuth>
                    }
                />
                <Route
                    path='/users'
                    element={
                        <RequireAuth>
                            <Users />
                        </RequireAuth>
                    }
                />
                <Route path='*' element={<NoMatch />} />
            </Route>
        </Routes>
    )
}

function RequireAuth({ children }: { children: JSX.Element }) {
    let auth = useAuth()
    let location = useLocation()

    if (!auth.authChecked) {
        return null
    }

    if (!auth.isAuthorized) {
        return <Navigate to='/login' state={{ from: location }} replace />
    }

    return children
}

function Layout() {
    let { signOut } = useAuth()

    return (
        <div>
            <nav>
                <ul>
                    <li>
                        <Link to='/'>Home</Link>
                    </li>
                    <hr />
                    <li>
                        <Link to='/leagues'>Leagues</Link>
                    </li>
                    <li>
                        <Link to='/league-types'>League types</Link>
                    </li>
                    <li>
                        <Link to='/league-divisions'>League divisions</Link>
                    </li>
                    <li>
                        <Link to='/league-formats'>League formats</Link>
                    </li>
                    <li>
                        <Link to='/teams'>Teams</Link>
                    </li>
                    <li>
                        <Link to='/positions'>Positions</Link>
                    </li>
                    <li>
                        <Link to='/players'>Players</Link>
                    </li>
                    <li>
                        <Link to='/documents'>Documents</Link>
                    </li>
                    {/* <hr />
                    <li>
                        <Link to='/training-fields'>Training fields</Link>
                    </li>
                    <li>
                        <Link to='/training-games'>Training games</Link>
                    </li> */}
                    {/*<li>*/}
                    {/*    <Link to='/training-games-players'>Training games players</Link>*/}
                    {/*</li>*/}
                    <hr />
                    {/*<li>*/}
                    {/*    <Link to='/nothing-here'>Nothing Here</Link>*/}
                    {/*</li>*/}
                    <li>
                        <Link to='/users'>Users</Link>
                    </li>
                    <li>
                        {/*@ts-ignore*/}
                        <a href={''} onClick={signOut}>
                            Logout
                        </a>
                    </li>
                </ul>
            </nav>

            <hr />

            <Outlet />
        </div>
    )
}

function Home() {
    return (
        <div>
            <h2>Home</h2>
        </div>
    )
}

function NoMatch() {
    return (
        <div>
            <h2>Nothing to see here!</h2>
            <p>
                <Link to='/'>Go to the home page</Link>
            </p>
        </div>
    )
}

export default App
